<div class="tw-relative">
  <div *ngIf="hotelAreasLoading" class="tw-absolute tw-h-full tw-w-full tw-bg-white/50 tw-z-50">
    <mh-core-lib-loader-wrapper 
      [type]="'spinner'"
      [loading]="hotelAreasLoading"
      className="tw-self-center" 
      spinnerClassName="tw-text-[50px]">
    </mh-core-lib-loader-wrapper>
  </div>

  <h3 class="tw-text-base tw-font-semibold tw-leading-none tw-mb-6" style="font-family: Rubik; letter-spacing: 0%;">
    {{ 'customer.configurations.hotel.areas.description' | translate }}
  </h3>
  
  <mh-core-lib-checkbox-input
    [options]="hotelAreas"
    [needTranslate]="false"
    [displayOptionsFn]="displayAreaName"
    [keySelected]="'active'"
    [ulClass]="'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4'"
    [listClass]="'tw-p-3 tw-rounded-lg hover:tw-bg-gray-50 tw-transition-colors'"
    [inputClass]="'tw-w-5 tw-h-5 tw-cursor-pointer'"
    [labelClass]="'tw-cursor-pointer tw-ml-3 tw-text-base tw-font-normal tw-leading-none'"
    (optionClicked)="toggleAreaActive($event)">
  </mh-core-lib-checkbox-input>
</div>

